import { render, staticRenderFns } from "./ListadoRDI.vue?vue&type=template&id=603d5d65&scoped=true"
import script from "./ListadoRDI.vue?vue&type=script&lang=js"
export * from "./ListadoRDI.vue?vue&type=script&lang=js"
import style0 from "./ListadoRDI.vue?vue&type=style&index=0&id=603d5d65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603d5d65",
  null
  
)

export default component.exports